export class CandidateCreateConstants {
    static readonly EDUCATION_TYPES = ['Full Time', 'Part time', 'Correspondence'];
    static readonly EMPLOYMENT_TYPES = ['Permanent', 'Contract'];
    static readonly PROFICIENCY = [
        { value: 'learner', viewValue: 'Learner' },
        { value: 'intermediate', viewValue: 'Intermediate' },
        { value: 'expert', viewValue: 'Expert' },];
    static readonly CANDIDATE_TAGS = ['Default', 'Confidential', 'Blacklist', 'Special'];
    static readonly GENDER = [
        { value: 'Male', viewValue: 'Male' },
        { value: 'Female', viewValue: 'Female' },
        { value: 'Non-Binary', viewValue: 'Non-Binary' },
        { value: 'Undisclosed', viewValue: 'Undisclosed' },
        { value: 'Unavailable', viewValue: 'Unavailable' }
    ];
    static readonly SALUTATION_OPTIONS = ["Mr", "Mrs", "Miss", "Ms", "Dr"];
    static readonly CANDIDATE_FLAGS = ['Default', 'Confidential', 'Blacklist', 'Special'];
    static readonly DEGREE = ['Bachelor of Engineering/Tech',
        'Bachelor of Science (BSC)',
        'Bachelor of Arts (BA)',
        'Bachelor Of Computer Application(BCA) ',
        'Bachelors of Architecture (BArch)',
        'Bachelor of Commerce',
        'Masters of Business Administration (MBA) ',
        'Post Graduate Diploma (PGD)',
        'Masters of Engineering/Tech',
        'Master of Commerce(Mcom)',
        'Master of Science (MSC/MS)',
        'Master of Arts (MA)',
        'Masters of Architecture (Macrch)',
        'Master of Computer Application (MCA)',
        'Master of Philosophy(Mphil)',
        'Doctor of Philosophy (PhD)'];
    static readonly SOURCE_DETAILS = ['Career Website',
        'Job Portal',
        'LinkedIn',
        'HR Recruiter',
        'Employee Referral',
        // 'REZAYAT Staff',
        'Newspaper',
        'Job Fair',
        'Walk-in',
        'Vendor'];
    static readonly NATION = [
        'Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Antiguans', 'Argentinean', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani', 'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Barbudans', 'Batswana', 'Belarusian', 'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Brazilian', 'British', 'Bruneian', 'Bulgarian', 'Burkinabe', 'Burmese', 'Burundian', 'Cambodian', 'Cameroonian', 'Canadian', 'Cape Verdean', 'Central African', 'Chadian',
        'Chilean', 'Chinese', 'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech', 'Danish', 'Djibouti', 'Dominican', 'Dutch', 'East Timorese', 'Ecuadorean', 'Egyptian', 'Emirian', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian', 'Fijian', 'Filipino', 'Finnish', 'French', 'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinea-bissauan', 'Guinean', 'Guyanese', 'Haitian', 'Herzegovinian', 'Honduran',
        'Hungarian', 'Icelander', 'Indian', 'Indonesian', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian', 'Jamaican', 'Japanese', 'Jordanian', 'Kazakhstani', 'Kenyan', 'Kittian and Nevisian', 'Kuwaiti', 'Kyrgyz', 'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner', 'Lithuanian', 'Luxembourger', 'Macedonian', 'Malagasy', 'Malawian', 'Malaysian', 'Maldivan', 'Malian', 'Maltese', 'Marshallese', 'Mauritanian', 'Mauritian', 'Mexican', 'Micronesian', 'Moldovan',
        'Monacan', 'Mongolian', 'Moroccan', 'Mosotho', 'Motswana', 'Mozambican', 'Namibian', 'Nauruan', 'Nepalese', 'New Zealander', 'Ni-vanuatu', 'Nicaraguan', 'Nigerien', 'North korean', 'Northern irish', 'Norwegian', 'Omani', 'Pakistani', 'Palauan', 'Panamanian', 'Papua New Guinean', 'Paraguayan', 'Peruvian', 'Polish', 'Portuguese', 'Qatari', 'Romanian', 'Russian', 'Rwandan', 'Saint lucian', 'Salvadoran', 'Samoan', 'San marinese', 'Sao tomean', 'Saudi', 'Scottish', 'Senegalese', 'Serbian',
        'Seychellois', 'Sierra leonean', 'Singaporean', 'Slovakian', 'Slovenian', 'Solomon islander', 'Somali', 'South African', 'South Korean', 'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamer', 'Swazi', 'Swedish', 'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan', 'Trinidadian or Tobagonian', 'Tunisian', 'Turkish', 'Tuvaluan', 'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbekistani', 'Venezuelan', 'Vietnamese', 'Welsh', 'Yemenite', 'Zambian', 'Zimbabwean'
    ]
    // static readonly NATION = [
    //     { value: 'afghan', viewValue: 'Afghan' },
    //     { value: 'albanian', viewValue: 'Albanian' },
    //     { value: 'algerian', viewValue: 'Algerian' },
    //     { value: 'american', viewValue: 'American' },
    //     { value: 'andorran', viewValue: 'Andorran' },
    //     { value: 'angolan', viewValue: 'Angolan' },
    //     { value: 'antiguans', viewValue: 'Antiguans' },
    //     { value: 'argentinean', viewValue: 'Argentinean' },
    //     { value: 'armenian', viewValue: 'Armenian' },
    //     { value: 'australian', viewValue: 'Australian' },
    //     { value: 'austrian', viewValue: 'Austrian' },
    //     { value: 'azerbaijani', viewValue: 'Azerbaijani' },
    //     { value: 'bahamian', viewValue: 'Bahamian' },
    //     { value: 'bahraini', viewValue: 'Bahraini' },
    //     { value: 'bangladeshi', viewValue: 'Bangladeshi' },
    //     { value: 'barbadian', viewValue: 'Barbadian' },
    //     { value: 'barbudans', viewValue: 'Barbudans' },
    //     { value: 'batswana', viewValue: 'Batswana' },
    //     { value: 'belarusian', viewValue: 'Belarusian' },
    //     { value: 'belgian', viewValue: 'Belgian' },
    //     { value: 'belizean', viewValue: 'Belizean' },
    //     { value: 'beninese', viewValue: 'Beninese' },
    //     { value: 'bhutanese', viewValue: 'Bhutanese' },
    //     { value: 'bolivian', viewValue: 'Bolivian' },
    //     { value: 'bosnian', viewValue: 'Bosnian' },
    //     { value: 'brazilian', viewValue: 'Brazilian' },
    //     { value: 'british', viewValue: 'British' },
    //     { value: 'bruneian', viewValue: 'Bruneian' },
    //     { value: 'bulgarian', viewValue: 'Bulgarian' },
    //     { value: 'burkinabe', viewValue: 'Burkinabe' },
    //     { value: 'burmese', viewValue: 'Burmese' },
    //     { value: 'burundian', viewValue: 'Burundian' },
    //     { value: 'cambodian', viewValue: 'Cambodian' },
    //     { value: 'cameroonian', viewValue: 'Cameroonian' },
    //     { value: 'canadian', viewValue: 'Canadian' },
    //     { value: 'cape verdean', viewValue: 'Cape Verdean' },
    //     { value: 'central african', viewValue: 'Central African' },
    //     { value: 'chadian', viewValue: 'Chadian' },
    //     { value: 'chilean', viewValue: 'Chilean' },
    //     { value: 'chinese', viewValue: 'Chinese' },
    //     { value: 'colombian', viewValue: 'Colombian' },
    //     { value: 'comoran', viewValue: 'Comoran' },
    //     { value: 'congolese', viewValue: 'Congolese' },
    //     { value: 'costa rican', viewValue: 'Costa Rican' },
    //     { value: 'croatian', viewValue: 'Croatian' },
    //     { value: 'cuban', viewValue: 'Cuban' },
    //     { value: 'cypriot', viewValue: 'Cypriot' },
    //     { value: 'czech', viewValue: 'Czech' },
    //     { value: 'danish', viewValue: 'Danish' },
    //     { value: 'djibouti', viewValue: 'Djibouti' },
    //     { value: 'dominican', viewValue: 'Dominican' },
    //     { value: 'dutch', viewValue: 'Dutch' },
    //     { value: 'east timorese', viewValue: 'East Timorese' },
    //     { value: 'ecuadorean', viewValue: 'Ecuadorean' },
    //     { value: 'egyptian', viewValue: 'Egyptian' },
    //     { value: 'emirian', viewValue: 'Emirian' },
    //     { value: 'equatorial guinean', viewValue: 'Equatorial Guinean' },
    //     { value: 'eritrean', viewValue: 'Eritrean' },
    //     { value: 'estonian', viewValue: 'Estonian' },
    //     { value: 'ethiopian', viewValue: 'Ethiopian' },
    //     { value: 'fijian', viewValue: 'Fijian' },
    //     { value: 'filipino', viewValue: 'Filipino' },
    //     { value: 'finnish', viewValue: 'Finnish' },
    //     { value: 'french', viewValue: 'French' },
    //     { value: 'gabonese', viewValue: 'Gabonese' },
    //     { value: 'gambian', viewValue: 'Gambian' },
    //     { value: 'georgian', viewValue: 'Georgian' },
    //     { value: 'german', viewValue: 'German' },
    //     { value: 'ghanaian', viewValue: 'Ghanaian' },
    //     { value: 'greek', viewValue: 'Greek' },
    //     { value: 'grenadian', viewValue: 'Grenadian' },
    //     { value: 'guatemalan', viewValue: 'Guatemalan' },
    //     { value: 'guinea-bissauan', viewValue: 'Guinea-bissauan' },
    //     { value: 'guinean', viewValue: 'Guinean' },
    //     { value: 'guyanese', viewValue: 'Guyanese' },
    //     { value: 'haitian', viewValue: 'Haitian' },
    //     { value: 'herzegovinian', viewValue: 'Herzegovinian' },
    //     { value: 'honduran', viewValue: 'Honduran' },
    //     { value: 'hungarian', viewValue: 'Hungarian' },
    //     { value: 'icelander', viewValue: 'Icelander' },
    //     { value: 'indian', viewValue: 'Indian' },
    //     { value: 'indonesian', viewValue: 'Indonesian' },
    //     { value: 'iranian', viewValue: 'Iranian' },
    //     { value: 'iraqi', viewValue: 'Iraqi' },
    //     { value: 'irish', viewValue: 'Irish' },
    //     { value: 'israeli', viewValue: 'Israeli' },
    //     { value: 'italian', viewValue: 'Italian' },
    //     { value: 'ivorian', viewValue: 'Ivorian' },
    //     { value: 'jamaican', viewValue: 'Jamaican' },
    //     { value: 'japanese', viewValue: 'Japanese' },
    //     { value: 'jordanian', viewValue: 'Jordanian' },
    //     { value: 'kazakhstani', viewValue: 'Kazakhstani' },
    //     { value: 'kenyan', viewValue: 'Kenyan' },
    //     { value: 'kittian and nevisian', viewValue: 'Kittian and Nevisian' },
    //     { value: 'kuwaiti', viewValue: 'Kuwaiti' },
    //     { value: 'kyrgyz', viewValue: 'Kyrgyz' },
    //     { value: 'laotian', viewValue: 'Laotian' },
    //     { value: 'latvian', viewValue: 'Latvian' },
    //     { value: 'lebanese', viewValue: 'Lebanese' },
    //     { value: 'liberian', viewValue: 'Liberian' },
    //     { value: 'libyan', viewValue: 'Libyan' },
    //     { value: 'liechtensteiner', viewValue: 'Liechtensteiner' },
    //     { value: 'lithuanian', viewValue: 'Lithuanian' },
    //     { value: 'luxembourger', viewValue: 'Luxembourger' },
    //     { value: 'macedonian', viewValue: 'Macedonian' },
    //     { value: 'malagasy', viewValue: 'Malagasy' },
    //     { value: 'malawian', viewValue: 'Malawian' },
    //     { value: 'malaysian', viewValue: 'Malaysian' },
    //     { value: 'maldivan', viewValue: 'Maldivan' },
    //     { value: 'malian', viewValue: 'Malian' },
    //     { value: 'maltese', viewValue: 'Maltese' },
    //     { value: 'marshallese', viewValue: 'Marshallese' },
    //     { value: 'mauritanian', viewValue: 'Mauritanian' },
    //     { value: 'mauritian', viewValue: 'Mauritian' },
    //     { value: 'mexican', viewValue: 'Mexican' },
    //     { value: 'micronesian', viewValue: 'Micronesian' },
    //     { value: 'moldovan', viewValue: 'Moldovan' },
    //     { value: 'monacan', viewValue: 'Monacan' },
    //     { value: 'mongolian', viewValue: 'Mongolian' },
    //     { value: 'moroccan', viewValue: 'Moroccan' },
    //     { value: 'mosotho', viewValue: 'Mosotho' },
    //     { value: 'motswana', viewValue: 'Motswana' },
    //     { value: 'mozambican', viewValue: 'Mozambican' },
    //     { value: 'namibian', viewValue: 'Namibian' },
    //     { value: 'nauruan', viewValue: 'Nauruan' },
    //     { value: 'nepalese', viewValue: 'Nepalese' },
    //     { value: 'new zealander', viewValue: 'New Zealander' },
    //     { value: 'ni-vanuatu', viewValue: 'Ni-vanuatu' },
    //     { value: 'nicaraguan', viewValue: 'Nicaraguan' },
    //     { value: 'nigerien', viewValue: 'Nigerien' },
    //     { value: 'north korean', viewValue: 'North korean' },
    //     { value: 'northern irish', viewValue: 'Northern irish' },
    //     { value: 'norwegian', viewValue: 'Norwegian' },
    //     { value: 'omani', viewValue: 'Omani' },
    //     { value: 'pakistani', viewValue: 'Pakistani' },
    //     { value: 'palauan', viewValue: 'Palauan' },
    //     { value: 'panamanian', viewValue: 'Panamanian' },
    //     { value: 'papua new guinean', viewValue: 'Papua New Guinean' },
    //     { value: 'paraguayan', viewValue: 'Paraguayan' },
    //     { value: 'peruvian', viewValue: 'Peruvian' },
    //     { value: 'polish', viewValue: 'Polish' },
    //     { value: 'portuguese', viewValue: 'Portuguese' },
    //     { value: 'qatari', viewValue: 'Qatari' },
    //     { value: 'romanian', viewValue: 'Romanian' },
    //     { value: 'russian', viewValue: 'Russian' },
    //     { value: 'rwandan', viewValue: 'Rwandan' },
    //     { value: 'saint lucian', viewValue: 'Saint lucian' },
    //     { value: 'salvadoran', viewValue: 'Salvadoran' },
    //     { value: 'samoan', viewValue: 'Samoan' },
    //     { value: 'san marinese', viewValue: 'San marinese' },
    //     { value: 'sao tomean', viewValue: 'Sao tomean' },
    //     { value: 'saudi', viewValue: 'Saudi' },
    //     { value: 'scottish', viewValue: 'Scottish' },
    //     { value: 'senegalese', viewValue: 'Senegalese' },
    //     { value: 'serbian', viewValue: 'Serbian' },
    //     { value: 'seychellois', viewValue: 'Seychellois' },
    //     { value: 'sierra leonean', viewValue: 'Sierra leonean' },
    //     { value: 'singaporean', viewValue: 'Singaporean' },
    //     { value: 'slovakian', viewValue: 'Slovakian' },
    //     { value: 'slovenian', viewValue: 'Slovenian' },
    //     { value: 'solomon islander', viewValue: 'Solomon islander' },
    //     { value: 'somali', viewValue: 'Somali' },
    //     { value: 'south african', viewValue: 'South African' },
    //     { value: 'south korean', viewValue: 'South Korean' },
    //     { value: 'spanish', viewValue: 'Spanish' },
    //     { value: 'sri lankan', viewValue: 'Sri Lankan' },
    //     { value: 'sudanese', viewValue: 'Sudanese' },
    //     { value: 'surinamer', viewValue: 'Surinamer' },
    //     { value: 'swazi', viewValue: 'Swazi' },
    //     { value: 'swedish', viewValue: 'Swedish' },
    //     { value: 'swiss', viewValue: 'Swiss' },
    //     { value: 'syrian', viewValue: 'Syrian' },
    //     { value: 'taiwanese', viewValue: 'Taiwanese' },
    //     { value: 'tajik', viewValue: 'Tajik' },
    //     { value: 'tanzanian', viewValue: 'Tanzanian' },
    //     { value: 'thai', viewValue: 'Thai' },
    //     { value: 'togolese', viewValue: 'Togolese' },
    //     { value: 'tongan', viewValue: 'Tongan' },
    //     { value: 'trinidadian or tobagonian', viewValue: 'Trinidadian or Tobagonian' },
    //     { value: 'tunisian', viewValue: 'Tunisian' },
    //     { value: 'turkish', viewValue: 'Turkish' },
    //     { value: 'tuvaluan', viewValue: 'Tuvaluan' },
    //     { value: 'ugandan', viewValue: 'Ugandan' },
    //     { value: 'ukrainian', viewValue: 'Ukrainian' },
    //     { value: 'uruguayan', viewValue: 'Uruguayan' },
    //     { value: 'uzbekistani', viewValue: 'Uzbekistani' },
    //     { value: 'venezuelan', viewValue: 'Venezuelan' },
    //     { value: 'vietnamese', viewValue: 'Vietnamese' },
    //     { value: 'welsh', viewValue: 'Welsh' },
    //     { value: 'yemenite', viewValue: 'Yemenite' },
    //     { value: 'zambian', viewValue: 'Zambian' },
    //     { value: 'zimbabwean', viewValue: 'Zimbabwean' }
    // ];
}